import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnlineNodeMetrics',
  props: {
    totalNodes: null,
    totalOnline: null
  },
  setup(__props: any) {

const props = __props as {
  totalNodes: number;
  totalOnline: number;
};



const onlineCountText = computed(
  () => `${props.totalOnline}/${props.totalNodes}`,
);

const onlinePercentage = computed(() =>
  Math.floor((props.totalOnline / props.totalNodes) * 100),
);

return { __sfc: true,props, onlineCountText, onlinePercentage }
}

})